import type { SectionId } from '~/types/sectionId';
import { findSectionConfigById } from '~/utils/findSectionConfigById';
import { resolveSectionPath } from '~/utils/resolveSectionPath';

export function useSectionConfigById(sectionId: SectionId) {
    const { $subSectionRegistry } = useNuxtApp();
    const { country } = useLanguage();

    return computed(() => findSectionConfigById($subSectionRegistry.value, country.value, sectionId));
}

export function useSectionPathById(sectionId: SectionId) {
    const sectionConfig = useSectionConfigById(sectionId);
    const { lang } = useLanguage();
    const countryLanguages = useCountryLanguages();

    return computed(() => {
        if (!sectionConfig.value) return null;
        return resolveSectionPath(sectionConfig.value, lang.value, countryLanguages);
    });
}

/**
 * Returns an empty path when the section is mounted at the country root and throws when it cannot be resolved.
 */
export function useRequiredSectionPathById(sectionId: SectionId) {
    const sectionPath = useSectionPathById(sectionId);

    return computed(() => {
        if (sectionPath.value === null) {
            throw new Error(`Section path could not be resolved: ${sectionId}`);
        }
        return sectionPath.value;
    });
}
